import action from "../../decorators/action.decorator";
import reducer, { InitSchemaReducer } from "../../decorators/reducer.decorator";
import { DIContainerKeys } from "../../di-container/di-container.keys";
import { Entities } from "../../store/entities/entities.enum";
import { HttpService } from "../http.service";
import loader from "../../decorators/loader.decorator";
import { Loaders } from "../../store/loaders/loaders.enum";
import type AddMemberDto from "./dto/add-member.dto";
import flagger from "../../decorators/flagger.decorator";
import { Flaggers } from "../../store/flaggers/flaggers.enum";

export const MembersAccessEffectActions = {
  addMember: `${Entities.MembersAccess}_addMember`,
};

const initSchema: InitSchemaReducer = {
  definitions: {  },
  options: { idAttribute: '' },
};

@reducer({
  entityName: Entities.MembersAccess,
  initSchema,
  aliasName: DIContainerKeys.MembersAccessService,
})
export class MembersAccessService extends HttpService {
  @loader(Loaders.AddMemberLoader)
  @flagger(Flaggers.AddMemberAccessModalFlagger)
  @action(DIContainerKeys.MembersAccessService)
  public *addMember(dto: AddMemberDto): Generator<any, void, any> {
    
  }

  @loader(Loaders.ResetPasswordLoader)
  @flagger(Flaggers.ResetPasswordModalFlagger)
  @action(DIContainerKeys.MembersAccessService)
  public *resetPassword(): Generator<any, void, any> {
    
  }
}
